import { User } from '@api';
import { createContext } from 'react';


export interface UserContextValue {
    users: User[];
}

export const UserContext = createContext<UserContextValue>({
    users: []
});
